module.exports = __webpack_public_path__ + "static/media/ecommerce-icon.4f0cc7cf.png";